import {SearchModelBase} from './SearchModelBase';
import * as XCol from '../../framework.core/XExportColumn';

export class ReportScheduleListItem extends SearchModelBase {
    id: number = 0;
    reportName: string = '';
    customerName: string = '';
    shipmentType: string ='';
    frequency: string = '';
    sendTime: string = '';
    startDate: string|null = null;
    fromStartDate: string|null = null;
    toStartDate: string|null = null;
    endDate: string|null = null;
    fromEndDate: string|null = null;
    toEndDate: string|null = null;
    u1Date: string|null = null;
    fromU1Date: string|null = null;
    toU1Date: string|null = null;
    u2Date: string|null = null;
    fromU2Date: string|null = null;
    toU2Date: string|null = null;
    isPaused: boolean =false;
    lastAction: string = '';
    u1Id: string = '';
    u2Id: string = '';
    remark: string = '';

    preview: string = ''; 
    schStatus: string = '';

    private static ExportCollection: XCol.XExportColumn[] = [
        XCol.Create({ col: 0, text: 'Status', width: 90, dataIndex: 'schStatus', hiddenInColumnSetup: true}),
        XCol.Create({ col: 1, text: 'Report Name', width: 300, dataIndex: 'reportName' ,defaultColumnFocus:true }),
        XCol.Create({ col: 2, text: 'Customer', width: 250, dataIndex: 'customerName' }),
        XCol.Create({ col: 3, text: 'Type', width: 60, dataIndex: 'shipmentType', align: XCol.XAlignType.Center}),
        XCol.Create({ col: 4, text: 'Frequency', width: 100, dataIndex: 'frequency',align: XCol.XAlignType.Center}),
        XCol.Create({ col: 3, text: 'Time', width: 80, dataIndex: 'sendTime', align: XCol.XAlignType.Center}),
        XCol.Create({ col: 5, text: 'Start Date', width: 90, dataIndex: 'startDate', type: XCol.XCellType.Date, align: XCol.XAlignType.Center}),
        XCol.Create({ col: 6, text: 'End Date', width: 90, dataIndex: 'endDate', type: XCol.XCellType.Date, align: XCol.XAlignType.Center}),
        //XCol.Create({ col: 7, text: 'Paused', width: 50, dataIndex: 'isPaused', type: XCol.XCellType.Bool, align: XCol.XAlignType.Center}),
        XCol.Create({ col: 7, text: 'Remark', width: 200, dataIndex: 'remark' }),
        XCol.Create({ col: 8, text: 'Report', width: 70, dataIndex: 'preview'}),
        XCol.Create({ col: 9, text: 'Last Action', width: 180, dataIndex: 'lastAction',}),
        XCol.Create({ col: 10, text: 'Create Date', width: 100, dataIndex: 'u1Date', type: XCol.XCellType.DateTime, align: XCol.XAlignType.Center, visible: false }),
        XCol.Create({ col: 11, text: 'Create by', width: 100, dataIndex: 'u1Id', visible: false }),
        XCol.Create({ col: 12, text: 'Update Date', width: 100, dataIndex: 'u2Date', type: XCol.XCellType.DateTime, align: XCol.XAlignType.Center, visible: false }),
        XCol.Create({ col: 13, text: 'Update by', width: 100, dataIndex: 'u2Id', visible: false }),

    ];


    public static getExportCollection(): XCol.XExportColumn[] {
      return this.ExportCollection;
    };
	
    public static OrderBy = { orderBy: ReportScheduleListItem.prototype.id, orderByAscending: false };

    public static formatData(data: ReportScheduleListItem[]) {
        return data.map((d: ReportScheduleListItem, index: number) => ({
          ...d,
        }));
    }
    
    public static MapSearchFields:{[key: string]: {[key: string]: string}} = {
      startDate: {from: 'fromStartDate', to: 'toStartDate'},
      endDate: {from: 'fromEndDate', to: 'toEndDate'},
      u1Date: {from: 'fromU1Date', to: 'toU1Date'},
      u2Date: {from: 'fromU2Date', to: 'toU2Date'},

    }
}
